import { defineComponent as _defineComponent } from 'vue'
import { getDateRangeFormatted, getTimeRangeFormatted } from '@/services/date'
import { mdiFacebook, mdiTwitter } from '@mdi/js'
import { IEvent } from '@/enitites/event'
import { ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import EventStaffUserChip from './EventStaffUserChip.vue'
import EventAllMembers from './EventAllMembers.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventStaff',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as {
  event: IEvent
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const { getImageById } = useImage()


const isShowWhoIsGoing = ref(false)
const eventUrl = window.location.href
const twitterUrl = `https://twitter.com/intent/tweet?text=${props.event.title} - ${getDateRangeFormatted(
  props.event.dateStart,
  props.event.dateEnd
)} - ${getTimeRangeFormatted(props.event.dateStart, props.event.dateEnd)} - ${props.event.locationAddress}&url=${eventUrl}`
const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(eventUrl)}`

return { __sfc: true,getImageById, props, isShowWhoIsGoing, eventUrl, twitterUrl, facebookUrl, mdiFacebook, mdiTwitter, EventStaffUserChip, EventAllMembers }
}

})